var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectorRef, ElementRef, OnInit, QueryList, } from '@angular/core';
import { MatTabGroup } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { CropperSettings } from 'ngx-img-cropper';
import { isNullOrUndefined } from 'util';
import { config } from '../../../../../config/config';
import { StyleCommand, StyleModel } from '../../../../commands/hub/style.command';
import { UpdateCityCommand } from '../../../../commands/hub/update.city.command';
import { BaseComponent } from '../../../../common/components/base.component';
import { localStorageKeys } from '../../../../common/constants/local.storage.keys';
import { ImageService } from '../../../../services/image.service';
import { VisitorDataCache } from '../../../../stores/visitor.calendar.store';
import { ImageCropperWithPreviewComponent } from '../../../../common/components/image.cropper/image.cropper.component';
import { AlertifyService } from '../../../../services/alertify.service';
import { LogoCommand } from '../../export.pdf.modal/export.pdf.modal.provider';
import { SuccessWrapComponent } from '../../../../common/components/success.wrap/success.wrap.component';
import { ModalService } from '../../../../common/services/modal.service';
import { CustomizationApiService } from '../../../../services/customization.api.service';
import { EventTimeService } from '../../../../services/event.time.service';
import { HubApiService } from '../../../../services/hub.api.service';
import { VisitorApiService } from '../../../../services/visitor.api.service';
import { HubFacebookLocationFeedsStore, HubFacebookPageFeedsStore, HubLogoStore, PDFSettingsStore, ToggleStore, } from '../../../../stores/hub.calendar.store';
import { HubComponent } from '../../hub.component';
import { HubVisitorFeatureToggle } from '../../../../models/hub/hub.visitor.feature.toggle';
import * as jwt_decode from 'jwt-decode';
var StyleComponent = /** @class */ (function (_super) {
    __extends(StyleComponent, _super);
    function StyleComponent(hubApiService, formBuilder, activatedRoute, customizationService, parent, modalService, imageService, hubFacebookFeedsStore, hubLogoStore, pdfSettingsStore, hubFacebookLocationFeedsStore, alertify, visitorApiService, togglesStore, cd) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.hubApiService = hubApiService;
        _this.formBuilder = formBuilder;
        _this.activatedRoute = activatedRoute;
        _this.customizationService = customizationService;
        _this.parent = parent;
        _this.modalService = modalService;
        _this.imageService = imageService;
        _this.hubFacebookFeedsStore = hubFacebookFeedsStore;
        _this.hubLogoStore = hubLogoStore;
        _this.pdfSettingsStore = pdfSettingsStore;
        _this.hubFacebookLocationFeedsStore = hubFacebookLocationFeedsStore;
        _this.alertify = alertify;
        _this.visitorApiService = visitorApiService;
        _this.togglesStore = togglesStore;
        _this.cd = cd;
        _this.updateCityCommand = new UpdateCityCommand();
        _this.hubName = null;
        _this.isLoadingCalendarStyle = false;
        _this.isLoadingMenuStyle = false;
        _this.isSideBar = true;
        _this.isHideEditorChoice = true;
        _this.isLoadingFeeds = false;
        _this.defaultImg = config.defaultImageUrl;
        _this.sidebarImage = config.sidebarImageUrl;
        _this.topbarImage = config.topbarImageUrl;
        _this.tourSideImg = config.tripPlannerTourSideImg;
        _this.mapImg = config.mapImg;
        _this.timeSample = EventTimeService.convert(new Date());
        _this.cards = [1];
        _this.style = new StyleModel();
        _this.defaultStyle = new StyleCommand();
        _this.logo = {
            isDefault: true,
            url: '',
        };
        _this.tpHomeImage = {
            isDefault: true,
            url: '',
        };
        _this.maxCroppedWidth = 800;
        _this.featuresToggle = new HubVisitorFeatureToggle();
        _this.multiCities = {
            active: false,
            cityBlock: {
                active: true,
            },
            regions: [],
            tours: [],
        };
        _this.tpBG = config.tripPlannerWelcomeImg;
        _this.version = {
            event: {
                version: 'V2',
            },
            place: {
                version: 'V2',
            },
            tripPlanner: {
                version: 'V2',
            },
            clientDashboard: {
                version: 'V2',
            },
        };
        _this.cropperSettings = new CropperSettings();
        _this.cropperSettingsForPDF = new CropperSettings();
        _this.logoData = {};
        _this.tpHomeImageData = {};
        _this.PDFSettings = {
            pdf: {
                headerImage: {
                    event: { isDefault: true, url: null },
                    place: { isDefault: true, url: null },
                    tour: { isDefault: true, url: null },
                    trip: { isDefault: true, url: null },
                },
            },
            eventCalendarURL: null,
            placeCalendarURL: null,
            moreToursURL: null,
        };
        _this.PDFSettingImageCorperData = {
            event: {},
            place: {},
            tour: {},
            trip: {},
        };
        _this.form = _this.formBuilder.group({
            regionName: [null, []],
        });
        _this.tpBG = _this.imageService.imageSourceUrl(_this.tpBG);
        return _this;
    }
    StyleComponent.prototype.ngOnInit = function () {
        var _this = this;
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        this.parent.location = 'Style Customization';
        this.isLoadingCalendarStyle = true;
        this.isLoadingMenuStyle = true;
        this.customEventForm = this.formBuilder.group({
            btnText: [null, []],
            type: [null, []],
            feedId: [null, []],
        });
        setTimeout(function () {
            _this.defaultStyle.defaultButton.backgroundColor = _this.defaultButtons.first.nativeElement.style.backgroundColor;
            _this.defaultStyle.eventButton.backgroundColor = _this.eventButtons.first.nativeElement.style.backgroundColor;
            _this.defaultStyle.placeButton.backgroundColor = _this.placeButtons.first.nativeElement.style.backgroundColor;
            _this.defaultStyle.pinnedEventBorder.borderColor =
                _this.pinnedEventBorders.first.nativeElement.style.backgroundColor;
            _this.defaultStyle.detailButton.backgroundColor = _this.detailButtons.first.nativeElement.style.backgroundColor;
            _this.defaultStyle.sidebarUnderline.color = _this.sidebarUnderlines.first.nativeElement.style.backgroundColor;
        });
        this.customizationService.getStyle(this.hubName).subscribe(function (style) {
            _this.mapStyle(style);
        });
        this.customizationService.getCalendarStyle(this.hubName).subscribe(function (style) {
            _this.calendarStyle = {
                event: style && style.event ? style.event : style.style || 'default',
                place: style && style.place ? style.place : style.style || 'default',
                eventDetails: style && style.eventDetails ? style.eventDetails : style.eventDetails || 'default',
            };
            _this.isLoadingCalendarStyle = false;
        });
        this.customizationService.getMenuStyle(this.hubName).subscribe(function (menuStyle) {
            _this.isSideBar = menuStyle.isSideBar == undefined || menuStyle.isSideBar;
            _this.isLoadingMenuStyle = false;
        });
        this.customizationService.getIgVersion(this.hubName).subscribe(function (version) {
            if (version && version.event) {
                _this.version = version;
            }
            console.log('version', version);
        });
        setTimeout(function () {
            var rect = _this.tab._elementRef.nativeElement.getBoundingClientRect(); //1228 / 2;
            var width = (rect.width - 18 * 4 - 12) / 2;
            var height = (width * 60) / 210;
            _this.cropperSettingsForPDF = _this.imageService.createImageCropperSetting(width, height, true);
            _this.cropperSettings = _this.imageService.createImageCropperSetting(width, height, false);
            _this.customizationService.getLogo(_this.hubName).subscribe(function (logo) {
                _this.logo.isDefault = isNullOrUndefined(logo) || isNullOrUndefined(logo.isDefault) || logo.isDefault;
                _this.logo.url = isNullOrUndefined(logo) ? null : logo.url;
                if (_this.logo.url) {
                    _this.logoData.image = _this.logo.url;
                    console.log('logo', _this.logo);
                    // this.logoImageSet('logo');
                    setTimeout(function () {
                        // console.log('this.logoCropper', this.logoCropper);
                        // this.logoCropper && this.logoCropper.setImage(this.logo.url);
                        _this.logoCropper && _this.logoCropper.setImageData(_this.cropperSettings);
                    });
                }
            });
            _this.customizationService.getPDFSettings(_this.hubName).subscribe(function (settings) {
                _this.PDFSettings.pdf.headerImage.event.isDefault =
                    isNullOrUndefined(settings) ||
                        isNullOrUndefined(settings.pdf.headerImage.event.isDefault) ||
                        settings.pdf.headerImage.event.isDefault;
                _this.PDFSettings.pdf.headerImage.event.url = _this.PDFSettings.pdf.headerImage.event.isDefault
                    ? null
                    : settings.pdf.headerImage.event.url;
                if (_this.PDFSettings.pdf.headerImage.event.url && _this.PDFSettings.pdf.headerImage.event.url.length) {
                    _this.PDFSettingImageCorperData.event.image = _this.PDFSettings.pdf.headerImage.event.url[0];
                }
                _this.PDFSettings.pdf.headerImage.place.isDefault =
                    isNullOrUndefined(settings) ||
                        isNullOrUndefined(settings.pdf.headerImage.place.isDefault) ||
                        settings.pdf.headerImage.place.isDefault;
                _this.PDFSettings.pdf.headerImage.place.url = _this.PDFSettings.pdf.headerImage.place.isDefault
                    ? null
                    : settings.pdf.headerImage.place.url;
                if (_this.PDFSettings.pdf.headerImage.place.url && _this.PDFSettings.pdf.headerImage.place.url.length) {
                    _this.PDFSettingImageCorperData.place.image = _this.PDFSettings.pdf.headerImage.place.url[0];
                }
                _this.PDFSettings.pdf.headerImage.tour.isDefault =
                    isNullOrUndefined(settings) ||
                        isNullOrUndefined(settings.pdf.headerImage.tour.isDefault) ||
                        settings.pdf.headerImage.tour.isDefault;
                _this.PDFSettings.pdf.headerImage.tour.url = _this.PDFSettings.pdf.headerImage.tour.isDefault
                    ? null
                    : settings.pdf.headerImage.tour.url;
                if (_this.PDFSettings.pdf.headerImage.tour.url) {
                    _this.PDFSettingImageCorperData.tour.image = _this.PDFSettings.pdf.headerImage.tour.url;
                }
                _this.PDFSettings.pdf.headerImage.trip.isDefault =
                    isNullOrUndefined(settings) ||
                        isNullOrUndefined(settings.pdf.headerImage.trip.isDefault) ||
                        settings.pdf.headerImage.trip.isDefault;
                _this.PDFSettings.pdf.headerImage.trip.url = _this.PDFSettings.pdf.headerImage.trip.isDefault
                    ? null
                    : settings.pdf.headerImage.trip.url;
                if (_this.PDFSettings.pdf.headerImage.trip.url) {
                    _this.PDFSettingImageCorperData.trip.image = _this.PDFSettings.pdf.headerImage.trip.url;
                }
                setTimeout(function () {
                    _this.eventImgCropper && _this.eventImgCropper.setImageData(_this.cropperSettingsForPDF);
                    _this.placeImgCropper && _this.placeImgCropper.setImageData(_this.cropperSettingsForPDF);
                });
            });
        });
        this.togglesStore.toggleCommand.takeUntil(this.isDestroyed).subscribe(function (toggle) {
            if (toggle) {
                _this.featuresToggle = toggle;
                _this.featuresToggle.calendarViewLayout = !!toggle.calendarViewLayout;
                _this.featuresToggle.itinerary = isNullOrUndefined(toggle.itinerary) ? true : toggle.itinerary;
                _this.featuresToggle.multipleCities = !!toggle.multipleCities;
                if (_this.multiCities.active) {
                    _this.hubApiService.getCityBlockToggle(_this.hubName).subscribe(function (block) {
                        _this.multiCities.cityBlock.active = !isNullOrUndefined(block.active) ? block.active : true;
                    });
                }
            }
        });
    };
    Object.defineProperty(StyleComponent.prototype, "canShowCalendarViewLayout", {
        get: function () {
            return !!this.featuresToggle.calendarViewLayout;
        },
        enumerable: true,
        configurable: true
    });
    StyleComponent.prototype.toDefault = function () {
        var _this = this;
        if (this.style.defaultButton.backgroundColor.isDefault) {
            this.style.defaultButton.backgroundColor.value = this.defaultStyle.defaultButton.backgroundColor;
            this.defaultButtons.forEach(function (x) {
                x.nativeElement.style.backgroundColor = _this.style.defaultButton.backgroundColor.value;
            });
        }
        if (this.style.eventButton.backgroundColor.isDefault) {
            this.style.eventButton.backgroundColor.value = this.defaultStyle.eventButton.backgroundColor;
            this.eventButtons.forEach(function (x) {
                x.nativeElement.style.backgroundColor = _this.style.eventButton.backgroundColor.value;
            });
        }
        if (this.style.placeButton.backgroundColor.isDefault) {
            this.style.placeButton.backgroundColor.value = this.defaultStyle.placeButton.backgroundColor;
            this.placeButtons.forEach(function (x) {
                x.nativeElement.style.backgroundColor = _this.style.placeButton.backgroundColor.value;
            });
        }
        if (this.style.pinnedEventBorder.borderColor.isDefault) {
            this.style.pinnedEventBorder.borderColor.value = this.defaultStyle.pinnedEventBorder.borderColor;
            this.pinnedEventBorders.forEach(function (x) {
                x.nativeElement.style.borderColor = _this.style.pinnedEventBorder.borderColor.value;
            });
        }
        if (this.style.detailButton.backgroundColor.isDefault) {
            this.style.detailButton.backgroundColor.value = this.defaultStyle.detailButton.backgroundColor;
            this.detailButtons.forEach(function (x) {
                x.nativeElement.style.backgroundColor = _this.style.detailButton.backgroundColor.value;
            });
        }
        if (this.style.sidebarUnderline.color.isDefault) {
            this.style.sidebarUnderline.color.value = this.defaultStyle.sidebarUnderline.color;
            this.sidebarUnderlines.forEach(function (x) {
                x.nativeElement.style.backgroundColor = _this.style.sidebarUnderline.color.value;
            });
        }
    };
    StyleComponent.prototype.toTPDefault = function () { };
    StyleComponent.prototype.chooseColor = function () {
        var _this = this;
        setTimeout(function () {
            _this.defaultButtons.forEach(function (x) {
                x.nativeElement.style.backgroundColor = _this.style.defaultButton.backgroundColor.value;
            });
            _this.eventButtons.forEach(function (x) {
                x.nativeElement.style.backgroundColor = _this.style.eventButton.backgroundColor.value;
            });
            _this.placeButtons.forEach(function (x) {
                x.nativeElement.style.backgroundColor = _this.style.placeButton.backgroundColor.value;
            });
            _this.pinnedEventBorders.forEach(function (x) {
                x.nativeElement.style.borderColor = _this.style.pinnedEventBorder.borderColor.value;
            });
            _this.detailButtons.forEach(function (x) {
                x.nativeElement.style.backgroundColor = _this.style.detailButton.backgroundColor.value;
            });
            _this.sidebarUnderlines.forEach(function (x) {
                x.nativeElement.style.backgroundColor = _this.style.sidebarUnderline.color.value;
            });
        });
    };
    StyleComponent.prototype.saveColor = function (event) {
        var _this = this;
        var command = this.createCmdAndSetColor();
        // this.removeColorPrefix(command);
        this.customizationService
            .setStyle(this.hubName, command)
            .finally(event.complete)
            .subscribe(function () {
            _this.alertify.successfully('Change the color');
        });
    };
    StyleComponent.prototype.saveTPColor = function (param) {
        var _this = this;
        console.log('param.command.tripPlanner', param.command.tripPlanner);
        var command = this.createCmdAndSetColor();
        command.tripPlanner = param.command.tripPlanner;
        // this.removeColorPrefix(command);
        this.customizationService
            .setStyle(this.hubName, command)
            .finally(param.event.complete)
            .subscribe(function () {
            _this.alertify.successfully('Change the color');
        });
    };
    StyleComponent.prototype.createCmdAndSetColor = function () {
        var command = new StyleCommand();
        command.defaultButton.backgroundColor = this.style.defaultButton.backgroundColor.isDefault
            ? null
            : this.style.defaultButton.backgroundColor.value;
        command.eventButton.backgroundColor = this.style.eventButton.backgroundColor.isDefault
            ? null
            : this.style.eventButton.backgroundColor.value;
        command.placeButton.backgroundColor = this.style.placeButton.backgroundColor.isDefault
            ? null
            : this.style.placeButton.backgroundColor.value;
        command.pinnedEventBorder.borderColor = this.style.pinnedEventBorder.borderColor.isDefault
            ? null
            : this.style.pinnedEventBorder.borderColor.value;
        command.detailButton.backgroundColor = this.style.detailButton.backgroundColor.isDefault
            ? null
            : this.style.detailButton.backgroundColor.value;
        command.sidebarUnderline.color = this.style.sidebarUnderline.color.isDefault
            ? null
            : this.style.sidebarUnderline.color.value;
        return command;
    };
    StyleComponent.prototype.mapStyle = function (style) {
        var _this = this;
        /**
         * utilize the server side stored style to UI
         * */
        Object.keys(this.style).forEach(function (x) {
            if (x !== 'tripPlanner') {
                var colorType_1 = ['backgroundColor', 'borderColor', 'color'].first(function (y) { return !!_this.style[x][y]; });
                _this.style[x][colorType_1].value = style[x][colorType_1] || _this.defaultStyle[x][colorType_1];
                _this.style[x][colorType_1].isDefault = !style[x][colorType_1];
                _this[x + 's'].forEach(function (ele) {
                    ele.nativeElement.style[x === 'sidebarUnderline' ? 'backgroundColor' : colorType_1] =
                        _this.style[x][colorType_1].value;
                });
            }
            else {
                var defaultStyle_1 = new StyleModel();
                Object.keys(style.tripPlanner).forEach(function (y) {
                    _this.style.tripPlanner[y].color.value = style.tripPlanner[y].color || defaultStyle_1.tripPlanner[y].color.value;
                    _this.style.tripPlanner[y].color.isDefault = !style.tripPlanner[y].color;
                });
            }
        });
    };
    StyleComponent.prototype.setMenuStyle = function () {
        var _this = this;
        this.customizationService.setMenuStyle(this.hubName, this.isSideBar).subscribe(function () {
            _this.alertify.successfully('Change the menu style');
        });
    };
    StyleComponent.prototype.setCalendarStyle = function () {
        var _this = this;
        this.customizationService.setCalendarStyle(this.hubName, this.calendarStyle).subscribe(function () {
            _this.alertify.successfully('Change the calendar style');
            var settingStorage = localStorage.getItem(localStorageKeys.visitorSettings);
            if (settingStorage) {
                var visitorSettings = JSON.parse(settingStorage);
                visitorSettings.calendarStyle = _this.calendarStyle;
                localStorage.setItem(localStorageKeys.visitorSettings, JSON.stringify(visitorSettings));
            }
        });
    };
    StyleComponent.prototype.logoImageSet = function (type, isForPDF) {
        var _this = this;
        setTimeout(function () {
            var width = 0, height = 0;
            if (!isForPDF) {
                width = Math.min(_this.maxCroppedWidth, _this.cropperSettings.croppedWidth);
                height = (width * _this.cropperSettings.croppedHeight) / _this.cropperSettings.croppedWidth;
            }
            else {
                width = Math.min(_this.maxCroppedWidth, _this.cropperSettings.croppedWidth);
                height = (width * _this.cropperSettings.croppedHeight) / _this.cropperSettings.croppedWidth;
            }
            var target = null;
            switch (type) {
                case 'logo':
                    target = _this.logoImage;
                    break;
                case 'event':
                    target = _this.pdfEventImage;
                    break;
                case 'place':
                    target = _this.pdfPlaceImage;
                    break;
                case 'tour':
                    target = _this.pdfTourImage;
                    break;
                case 'trip':
                    target = _this.pdfTripImage;
                    break;
                case 'tpHomeImage':
                    target = _this.pdfTripImage;
                    break;
                default:
                    break;
            }
            if (target && target.nativeElement) {
                target.nativeElement.style.width = width + "px";
                target.nativeElement.style.height = height + "px";
            }
        });
    };
    StyleComponent.prototype.saveLogo = function (event) {
        var _this = this;
        var imageFile = this.logo.isDefault ? null : this.imageService.getImageFileByBase64(this.logoData.image);
        //let data = {isDefault: this.logo.isDefault, url: this.logoData.image};
        //this.customizationService.setLogo(this.hubName, data)
        this.customizationService
            .setLogoFile(this.hubName, { isDefault: this.logo.isDefault, image: imageFile })
            .finally(event.complete)
            .subscribe(function (fileName) {
            _this.alertify.successfully('Change the logo');
            var logo = new LogoCommand();
            logo.url = _this.imageService.imageSourceUrl(fileName.fileName);
            logo.isDefault = _this.logo.isDefault;
            _this.hubLogoStore.logoCommand.next(logo);
            VisitorDataCache.logo = !logo.isDefault ? logo.url : '';
            // this.hubLogoStore.logoCommand.next(data);
            // VisitorDataCache.logo = !data.isDefault ? data.url : '';
        });
    };
    StyleComponent.prototype.onSelectedTabChange = function (event) {
        if (!window.location.href.includes('localhost')) {
            var authToken = localStorage.getItem(localStorageKeys.authToken);
            var tokenInfo = jwt_decode(authToken);
            try {
                var trackName = "click - customization - " + event.tab.textLabel;
                window['pendo'].track(trackName, {
                    accountId: tokenInfo.userName,
                    timestamp: Date.now(),
                    hubName: this.hubName
                });
            }
            catch (error) {
                console.error(error);
            }
        }
    };
    return StyleComponent;
}(BaseComponent));
export { StyleComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/customization/style/style.component.ts.pre-build-optimizer.js